import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const Confirmpopup = (props)=>{
const closePopup =() =>{
  props.CancelPopup();
}
const deletePost=()=>{
  props.handleDelete(props.DeletPostid);
}
const capitalize=(str)=>{
  return str.charAt(0).toUpperCase() + str.slice(1);
}
return(
<div>
      <Modal show={props.isConfirm} onHide={props.CancelPopup}
       dialogClassName="small-custom-modal  modal-dialog-centered">
        <Modal.Header closeButton>
        <div className="popupheader">
        <div className="mod-bor-icon" >
       <FontAwesomeIcon icon={faTrash} />
            </div>
            <div className="header">
              <div className="signuup">Delete {capitalize(props.type)}</div>
              <p className="Stronger"></p>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div>
          <p className="fov-text">Do you want to delete this {props.type}?</p>
          </div>
       
        </Modal.Body>

          <Modal.Footer className="full-w" >
                         <button type="button" className="cancel-btn" onClick={()=>closePopup()}>No</button>
                          <button className="next-btn"  onClick={()=>deletePost()}>Yes</button>
                </Modal.Footer>
      
      </Modal>
      
    </div>
);
  

};
export default Confirmpopup;